(function () {
  'use strict';

  /* @ngdoc object
   * @name Filters
   * @requires $stateProvider
   *
   * @description
   *
   */
  angular
    .module('Filters', [
      'ui.router',
      'Configuration'
    ]);

  angular
    .module('Filters')
    .config(config);

  function config() {
  }

})();
